// Per-tool help clips shown inside the EditDesign tool tooltips (Photoshoot Studio + shared edit overlay).
// Hosted on app_cdn; the Tooltip `video` prop hides itself if a URL 404s, so an unhosted tool degrades to text.
const BASE = "https://storage.googleapis.com/app_cdn/statics";
const v = (slug: string) => `${BASE}/${slug}.webm`;

export const PS_HELP_VIDEO = {
  glamRoom: v("photoshoot-glam-room"),
  poseEdit: v("photoshoot-pose-edit"),
  // One clip shared by the Face Fix tool and the Retouch submenu opener.
  faceFixRetouch: v("photoshoot-face-fix-retouch"),
  // One clip shared by the "Restore Details" tool and the Expand-Image 4K resolution chip.
  detailEdits4k: v("photoshoot-detail-edits-4k"),
} as const;

/**
 * Each clip's backoffice "Site Görselleri" slot (the url above is its fallback). Resolved where the clip plays:
 * `Tooltip` looks the url up (`components/Tooltip/helpVideoSlots`), so call sites keep passing `PS_HELP_VIDEO.*`.
 */
export const PS_HELP_VIDEO_SLOT: Record<keyof typeof PS_HELP_VIDEO, string> = {
  glamRoom: "canvas_help.photoshoot_glam_room",
  poseEdit: "canvas_help.photoshoot_pose_edit",
  faceFixRetouch: "canvas_help.photoshoot_face_fix_retouch",
  detailEdits4k: "canvas_help.photoshoot_detail_edits_4k",
};
